var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreeNodes(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 4.125V5.625H3.9375H5.0625H5.25V4.125H3.75ZM5.25 6.75H5.0625V8.0625H9.1875V6.75H9H7.875V5.625V4.125V3H9H10.5H11.625V4.125V5.625V6.75H10.5H10.3125V8.0625H14.1164L12.9328 6.97734L12.518 6.59766L13.2773 5.76797L13.6922 6.14766L15.9422 8.21016L16.3945 8.625L15.9422 9.03984L13.6922 11.1023L13.2773 11.482L12.518 10.6523L12.9328 10.2727L14.1164 9.1875H7.3125V10.5H7.5H8.625V11.625V13.125V14.25H7.5H6H4.875V13.125V11.625V10.5H6H6.1875V9.1875H2.0625H1.5V8.0625H2.0625H3.9375V6.75H3.75H2.625V5.625V4.125V3H3.75H5.25H6.375V4.125V5.625V6.75H5.25ZM6.1875 11.625H6V13.125H7.5V11.625H7.3125H6.1875ZM10.5 4.125H9V5.625H10.5V4.125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeNodes);
export default __webpack_public_path__ + "static/media/tree-nodes.c29ff0033d75d8fc9cfe080793fa224e.svg";
export { ForwardRef as ReactComponent };